import { useEffect } from 'react';
import { ObservableInput, Observer, Subject, switchAll } from 'rxjs';
import { useCreation } from '../hooks/useCreation';
import { useLatestValueRef } from '../hooks/useLatestValueRef';

export const useSubscription = <T>(
  observableInput: ObservableInput<T>,
  nextOrObserver: Partial<Observer<T>> | ((nextValue: T) => void),
): void => {
  const source = useCreation(() => new Subject<ObservableInput<T>>(), []);

  const nextOrObserverRef = useLatestValueRef(nextOrObserver);

  useEffect(() => {
    const observer: Partial<Observer<T>> =
      typeof nextOrObserverRef.current === 'function'
        ? { next: nextOrObserverRef.current }
        : nextOrObserverRef.current;

    const sub = source.pipe(switchAll()).subscribe(observer);

    return () => {
      sub.unsubscribe();
    };
  }, [nextOrObserverRef, source]);

  useEffect(() => {
    source.next(observableInput);
  }, [observableInput, source]);
};
